import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrl: './survey.component.scss',
})
export class SurveyComponent {
  public joinUsForm: FormGroup = new FormGroup({
    sellerType: new FormControl(''),
    category: new FormControl(''),
    description: new FormControl(''),
  });

  public showThanksScreen: boolean = false;
  public isLogin: any = 0;
  public selectedSurvey: {
    createdAt: number;
    description: string;
    endDate: number;
    id: number;
    memberSurveyQuestions: Array<any>;
    startDate: number;
    title: string;
    type: string;
    updatedAt: number;
  } = null;
  open: boolean = false;
  currentStep: number = 0; // Current step (initially 1)
  totalSteps: number = 0; // Total number of steps
  progress: number = 0; // Progress percentage
  checkboxForm: FormGroup;
  icons = {
    Pets: 'paw',
    Sports: 'volleyball',
    Business: 'business-time',
    Technology: 'microchip',
    Cooking: 'utensils',
  };

  // List of options for checkboxes
  checkboxList = [
    { id: 1, name: 'Pets' },
    { id: 2, name: 'Handyman' },
    { id: 3, name: 'Sports' },
    { id: 4, name: 'Teaching' },
    { id: 5, name: 'Music' },
    { id: 6, name: 'Fitness' },
    { id: 7, name: 'Child Care' },
    { id: 8, name: 'Food' },
    { id: 9, name: 'Education' },
  ];
  ageList = [
    { id: 1, name: '< 20' },
    { id: 2, name: '20-30' },
    { id: 3, name: ' 40-50' },
    { id: 4, name: '> 50' },
  ];
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private toastr: ToastrService,
    public commonService: CommonService
  ) {
    this.showThanksScreen = false;
    this.checkboxForm = this.fb.group({
      selectedCheckboxes: this.fb.array([]),
    });
    this.updateProgress();
    this.getSurvey();
    this.checkIfLogin();
  }
  // Move to the next step
  public nextStep() {
    this.specialSurveyCheck();

    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      this.updateProgress();
    }
  }

  public checkIfLogin(): void {
    this.local.getUserDetailsObserver().subscribe((user) => {
      this.isLogin = user?.id ? 1 : 0;
    });
  }

  // Move to the previous step
  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.updateProgress();
    }
  }

  // Calculate the progress percentage based on the current step
  updateProgress() {
    this.progress = (this.currentStep / this.totalSteps) * 100;
  }

  // Handling checkbox change event
  onCheckboxChange(event: any) {
    const selectedCheckboxes = this.checkboxForm.get(
      'selectedCheckboxes'
    ) as FormArray;
    if (event.target.checked) {
      selectedCheckboxes.push(this.fb.control(event.target.value));
    } else {
      const index = selectedCheckboxes.controls.findIndex(
        (x) => x.value === event.target.value
      );
      selectedCheckboxes.removeAt(index);
    }
  }

  public questions: Array<any> = []; //All Question of all survey in one set
  public surveyList: Array<any> = []; //All Question of all survey in one set
  public showSurveySelection: boolean = false;
  public getSurvey() {
    this.isLoading = true;
    this.auth
      .getAllMemberSurveyWithQuestion()
      .subscribe((resp: ApiResponse) => {
        this.isLoading = false;
        this.surveyList = resp.body.filter(
          (i) => i.memberSurveyQuestions.length > 0
        );
        if (this.surveyList.length > 1) {
          this.showSurveySelection = true;
        } else {
          this.selectedSurvey = this.surveyList[0];
          this.setQuestion(this.surveyList[0]);
        }
      }, (e) => {
        this.isLoading = false;
      });
  }

  public selectSurvey(survey) {
    this.selectedSurvey = survey;
    this.setQuestion(survey);
  }

  public setQuestion(value) {
    this.showSurveySelection = false;
    if (value) {
      this.questions = value.memberSurveyQuestions.map((i) => {
        if (i.question_type == 'multiple') {
          i.options = i.options.map((i) => {
            return {
              value: i,
              checked: false,
            };
          });
        } else if (i.question_type == 'single') {
          i['value'] = '';
        } else {
          i['text'] = '';
        }
        return i;
      });

      this.totalSteps = (this.questions || []).length;
      this.totalSteps =
        this.totalSteps > 0 ? this.totalSteps - 1 : this.totalSteps;
    }
  }

  public submit() {
    this.open = !this.open;

    if (
      this.selectedSurvey?.title.toLowerCase() == 'join us' &&
      this.questions[0].value == 'Seller'
    ) {
      this.questions[1].value = JSON.stringify(this.joinUsForm.value);
    }

    for (let i of this.questions) {
      if (i.question_type == 'multiple') {
        this.saveUserResponse(
          i.id,
          i.options.filter((i) => i.checked).map((i) => i.value),
          ''
        );
      } else if (i.question_type == 'single') {
        i.value ? this.saveUserResponse(i.id, { selected: i.value }, '') : '';
      } else {
        this.saveUserResponse(i.id, {}, i.text);
      }
    }
    this.getSurvey();
    this.commonService.getTagList();
    this.showThanksScreen = true;
  }

  public saveUserResponse(question_id, selected_option, response_text) {
    if (Object.keys(selected_option).length != 0 || response_text) {
      this.auth
        .addMemberSurveyQuestionsUserResponses({
          question_id: question_id,
          selected_option: selected_option,
          response_text: response_text,
        })
        .subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
        });
    }
  }

  public specialSurveyCheck() {
    if (this.selectedSurvey?.title.toLowerCase() == 'join us') {
      if (this.questions[0].value == 'Seller') {
      } else {
        this.questions[1].value = 'NA';
        this.totalSteps = 0;
        this.submit();
      }
    }
  }
}
